"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeInput = exports.valueValidation = void 0;
exports.ErrorMessage = ErrorMessage;
exports.MyAsyncTypeahead = MyAsyncTypeahead;
exports.TextOptionSelector = TextOptionSelector;
exports.TypeaheadStringSelector = TypeaheadStringSelector;
exports.ValueInPLNInput = ValueInPLNInput;
exports.FileInput = FileInput;
exports.RadioButtonGroup = RadioButtonGroup;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_bootstrap_typeahead_1 = require("react-bootstrap-typeahead");
require("react-bootstrap-typeahead/css/Typeahead.css");
require("../../../Css/styles.css");
const FormContext_1 = require("../FormContext");
const react_hook_form_1 = require("react-hook-form");
const react_number_format_1 = require("react-number-format");
const Yup = __importStar(require("yup"));
const CommonComponentsController_1 = require("../../Resultsets/CommonComponentsController");
const ToolsForms_1 = require("../../../React/Tools/ToolsForms");
function ErrorMessage({ errors, name }) {
    // Function to access nested properties
    const getNestedError = (errors, path) => {
        const keys = path.split("."); // Split the path into keys
        let current = errors;
        for (let key of keys) {
            if (current[key]) {
                current = current[key];
            }
            else {
                return null; // If the path does not exist, return null
            }
        }
        return current;
    };
    const error = getNestedError(errors, name);
    return react_1.default.createElement(react_1.default.Fragment, null, error && react_1.default.createElement(react_bootstrap_1.Form.Text, { className: "text-danger" }, error.message));
}
/** Jeśli multiple jest true to wartość pola jest tablicą obiektów, jeśli false to pojedynczym obiektem
 * @param name nazwa pola w formularzu - zostanie wysłane na serwer jako składowa obiektu FormData
 * @param repository repozytorium z którego pobierane są dane
 * @param labelKey nazwa pola w repozytorium które ma być wyświetlane w polu wyboru
 * @param searchKey nazwa pola w repozytorium które ma być wyszukiwane po stronie serwera (sprawdź odpowiedni controller) domyślnie jest równe labelKey
 * @param specialSerwerSearchActionRoute nazwa nietypowego route na serwerze która ma być wywołana zamiast standardowego z RepositoryReact
 * @param multiple czy pole wyboru ma być wielokrotnego wyboru
 * @param renderMenuItemChildren funkcja renderująca elementy listy wyboru (domyślnie wyświetla tylko labelKey)
 */
function MyAsyncTypeahead({ name, repository, labelKey, searchKey = labelKey, contextSearchParams = {}, specialSerwerSearchActionRoute, renderMenuItemChildren = (option) => react_1.default.createElement(react_1.default.Fragment, null, option[labelKey]), renderMenu, align = "justify", multiple = false, allowNew = false, showValidationInfo = true, readOnly = false, }) {
    const { register, control, setValue, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [options, setOptions] = (0, react_1.useState)([]);
    const lastQueryRef = (0, react_1.useRef)("");
    // Numer ostatniego wysłanego zapytania - starsze odpowiedzi (np. po szybkim
    // przeklikaniu filtrów) są odrzucane, żeby nie nadpisały aktualnej listy.
    const requestIdRef = (0, react_1.useRef)(0);
    async function handleSearch(query) {
        console.log(`🔍 [${name}] handleSearch rozpoczęty dla query:`, query);
        lastQueryRef.current = query;
        const requestId = ++requestIdRef.current;
        setIsLoading(true);
        const params = {
            [searchKey]: query,
            ...contextSearchParams,
        };
        try {
            const items = await repository.loadItemsFromServerPOST([params], specialSerwerSearchActionRoute, {
                skipCache: true,
            });
            console.log(`📦 [${name}] Otrzymano ${items.length} obiektów z API`, items);
            // ✅ WALIDACJA: Upewnij się że każdy obiekt ma labelKey
            const validatedData = items.map((item) => {
                if (typeof item === "string") {
                    return { [labelKey]: item };
                }
                return (0, ToolsForms_1.ensureLabelKey)(item, labelKey, `MyAsyncTypeahead[${name}]`);
            });
            console.log(`✅ [${name}] Po walidacji:`, validatedData);
            console.log(`🏷️ [${name}] labelKey="${labelKey}", pierwszy obiekt:`, validatedData[0]);
            if (requestId !== requestIdRef.current)
                return; // nieaktualna odpowiedź
            setOptions(validatedData);
            setIsLoading(false);
        }
        catch (error) {
            if (requestId !== requestIdRef.current)
                return;
            setIsLoading(false);
            console.error(`❌ MyAsyncTypeahead [${name}] - Błąd wyszukiwania:`, error);
            setOptions([]);
            // Opcjonalnie można pokazać toast lub alert użytkownikowi
        }
    }
    // Bypass client-side filtering by returning `true`. Results are already
    // filtered by the search endpoint, so no need to do it again.
    const filterBy = () => true;
    // Zmiana kryteriów kontekstowych (np. filtr statusów przełączony w nagłówku menu)
    // ponawia ostatnie zapytanie - inaczej lista zostałaby z wynikami dla starych kryteriów.
    const contextSearchParamsKey = JSON.stringify(contextSearchParams);
    (0, react_1.useEffect)(() => {
        if (lastQueryRef.current)
            handleSearch(lastQueryRef.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contextSearchParamsKey]);
    function handleOnChange(selectedOptions, field) {
        let valueToBeSent;
        if (selectedOptions.length > 0) {
            if (selectedOptions[0].customOption) {
                // Nowa wartość wprowadzona przez użytkownika
                valueToBeSent = multiple ? selectedOptions.map((opt) => opt[labelKey]) : selectedOptions[0][labelKey];
            }
            else {
                // Wybrana wartość z listy
                valueToBeSent = multiple ? selectedOptions : selectedOptions[0];
            }
        }
        else {
            valueToBeSent = null;
        }
        // Wybór zamyka wyszukiwanie - bez tego zmiana kryteriów kontekstowych
        // odpytywałaby serwer o nieaktualną już frazę.
        lastQueryRef.current = "";
        setValue(name, valueToBeSent);
        field.onChange(valueToBeSent);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, render: ({ field }) => {
                // Waliduj field.value przed przekazaniem do selected
                // Obiekty z formularza (domyślne wartości przy edycji) też muszą mieć labelKey
                const getValidatedSelected = () => {
                    if (!field.value)
                        return [];
                    const values = multiple ? field.value : [field.value];
                    const validated = values.map((item) => {
                        // ✅ Jeśli wartość jest stringiem (np. allowNew lub initData jako string), opakuj go dla UI
                        if (typeof item === "string") {
                            return { [labelKey]: item, customOption: true };
                        }
                        return (0, ToolsForms_1.ensureLabelKey)(item, labelKey, name);
                    });
                    console.log(`🏷️ [${name}] Walidacja selected values:`, {
                        original: field.value,
                        validated: validated,
                    });
                    return validated;
                };
                return (react_1.default.createElement(react_bootstrap_typeahead_1.AsyncTypeahead
                // Własne renderMenu omija wbudowane komunikaty AsyncTypeahead,
                // więc dokładamy do state `isLoading` - inaczej w trakcie
                // doczytywania menu pokazywałoby "brak wyników".
                , { 
                    // Własne renderMenu omija wbudowane komunikaty AsyncTypeahead,
                    // więc dokładamy do state `isLoading` - inaczej w trakcie
                    // doczytywania menu pokazywałoby "brak wyników".
                    renderMenu: renderMenu
                        ? (results, menuProps, state) => renderMenu(results, menuProps, { ...state, isLoading })
                        : undefined, align: align, filterBy: filterBy, id: `${name}-asyncTypeahead`, allowNew: allowNew, isLoading: isLoading, labelKey: labelKey, minLength: 2, onSearch: handleSearch, options: options, onChange: (items) => handleOnChange(items, field), onBlur: field.onBlur, selected: getValidatedSelected(), multiple: multiple, newSelectionPrefix: "Dodaj nowy: ", placeholder: "-- Wybierz opcj\u0119 --", renderMenuItemChildren: renderMenuItemChildren, isValid: showValidationInfo ? !(0, CommonComponentsController_1.hasError)(errors, name) : undefined, isInvalid: showValidationInfo ? (0, CommonComponentsController_1.hasError)(errors, name) : undefined }));
            } }),
        react_1.default.createElement(ErrorMessage, { errors: errors, name: name }),
        readOnly && react_1.default.createElement("input", { type: "hidden", ...register(name) })));
}
function TextOptionSelector({ options, showValidationInfo = true, name, as, label = name, multiple = false, }) {
    const { register, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    function makeLabel() {
        return label.charAt(0).toUpperCase() + label.slice(1);
    }
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: name, as: as },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, makeLabel()),
        react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "select", multiple: multiple, isValid: showValidationInfo ? !(0, CommonComponentsController_1.hasError)(errors, name) : undefined, isInvalid: showValidationInfo ? (0, CommonComponentsController_1.hasError)(errors, name) : undefined, ...register(name) },
            react_1.default.createElement("option", { value: "" }, "-- Wybierz opcj\u0119 --"),
            options.map((option, index) => (react_1.default.createElement("option", { key: index, value: option }, option)))),
        react_1.default.createElement(ErrorMessage, { errors: errors, name: name })));
}
/**
 * Komponent do wyboru opcji z listy stringów służy jako multiselect
 *
 * GPO-3: `optionLabel` pozwala pokazać człowiekowi inny napis niż przechowywana wartość.
 * Potrzebne tam, gdzie baza trzyma klucz (`DIFF_MINOR`), a na ekranie ma stać nazwa po
 * polsku („inny zapis”). Domyślnie napis = wartość, czyli wszystkie dotychczasowe
 * miejsca użycia zachowują się dokładnie jak dotąd.
 */
function TypeaheadStringSelector({ options, showValidationInfo = true, name = "status", label = name, as, optionLabel = (option) => option, }) {
    const { control, setValue, getValues, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    const multiple = true;
    (0, react_1.useEffect)(() => {
        // Set default value if undefined
        const currentValue = getValues(name);
        if (currentValue === undefined) {
            const defaultValue = multiple ? [] : "";
            setValue(name, defaultValue);
        }
    }, [setValue, getValues, multiple, name]);
    function handleOnChange(selectedOptions, field) {
        const valueToBeSent = multiple ? selectedOptions : selectedOptions[0] || "";
        setValue(name, valueToBeSent);
        field.onChange(valueToBeSent);
    }
    function setSelectedValue(field) {
        return Array.isArray(field.value) ? field.value : field.value ? [field.value] : [];
    }
    function makeLabel() {
        return label.charAt(0).toUpperCase() + label.slice(1);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: name, as: as },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, makeLabel()),
            react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, defaultValue: multiple ? [] : "", render: ({ field }) => (react_1.default.createElement(react_bootstrap_typeahead_1.Typeahead, { id: `${name}-controlled`, labelKey: (option) => optionLabel(option), multiple: multiple, options: options, onChange: (items) => handleOnChange(items, field), selected: setSelectedValue(field), placeholder: "-- Wybierz status --", isValid: showValidationInfo ? !errors?.[name] : undefined, isInvalid: showValidationInfo ? !!errors?.[name] : undefined, renderMenuItemChildren: (option) => react_1.default.createElement(react_1.default.Fragment, null, optionLabel(option)) })) }),
            react_1.default.createElement(ErrorMessage, { name: name, errors: errors }))));
}
/**
 * Wyświetla pole do wprowadzania wartości w PLN
 * @param showValidationInfo czy wyświetlać informacje o błędzie walidacji (domyślnie true)
 * @param keyLabel nazwa pola w formularzu - zostanie wysłane na serwer jako składowa obiektu FormData (domyślnie 'value')
 */
function ValueInPLNInput({ showValidationInfo = true, name = "value" }) {
    const { control, setValue, watch, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    const watchedValue = watch(name);
    (0, react_1.useEffect)(() => {
        setValue(name, watchedValue ?? "", { shouldValidate: true });
    }, [watchedValue, setValue]);
    const classNames = ["form-control"];
    if (showValidationInfo) {
        classNames.push((0, CommonComponentsController_1.hasError)(errors, name) ? "is-invalid" : "is-valid");
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.InputGroup, { className: "mb-3" },
            react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: name, render: ({ field }) => (react_1.default.createElement(react_number_format_1.NumericFormat, { ...field, value: watchedValue, thousandSeparator: " ", decimalSeparator: ".", decimalScale: 2, allowLeadingZeros: false, fixedDecimalScale: true, displayType: "input", allowNegative: false, onValueChange: (values) => {
                        setValue(name, values.floatValue);
                        //field.onChange(values.floatValue);
                    }, className: classNames.join(" "), valueIsNumericString: false })) }),
            react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { id: "basic-addon1" }, "PLN")),
        react_1.default.createElement(ErrorMessage, { name: name, errors: errors })));
}
exports.valueValidation = Yup.string()
    .typeError("Wartość jest wymagana")
    .required("Wartość jest wymagana")
    .test("valueValidation", "Wartość musi być mniejsza od 9 999 999 999", function (value) {
    if (value === undefined)
        return false;
    const parsedValue = parseFloat(value.replace(/[^0-9.]/g, "").replace(",", "."));
    return parsedValue < 9999999999;
});
exports.DateRangeInput = (0, react_1.forwardRef)(({ showValidationInfo = true, fromName, toName, label, defaultFromValue, defaultToValue, ...colProps }, ref) => {
    const { control, setValue, watch, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    const watchedFromValue = watch(fromName, defaultFromValue ?? "");
    const watchedToValue = watch(toName, defaultToValue ?? "");
    (0, react_1.useEffect)(() => {
        setValue(fromName, watchedFromValue ?? "", { shouldValidate: true });
        setValue(toName, watchedToValue ?? "", { shouldValidate: true });
    }, [watchedFromValue, watchedToValue, setValue]);
    const getClassName = (name) => {
        const classNames = ["form-control"];
        if (showValidationInfo) {
            classNames.push(hasError(errors, name) ? "is-invalid" : "is-valid");
        }
        return classNames.join(" ");
    };
    const hasError = (errors, name) => {
        return errors && errors[name];
    };
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, ref: ref, ...colProps },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, label),
        react_1.default.createElement(react_bootstrap_1.InputGroup, null,
            react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: fromName, render: ({ field }) => (react_1.default.createElement(react_bootstrap_1.Form.Control, { ...field, type: "date", value: watchedFromValue, onChange: (e) => setValue(fromName, e.target.value, { shouldValidate: true }), className: getClassName(fromName) })) }),
            react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { id: "date-to-label" }, "-"),
            react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: toName, render: ({ field }) => (react_1.default.createElement(react_bootstrap_1.Form.Control, { ...field, type: "date", value: watchedToValue, onChange: (e) => setValue(toName, e.target.value, { shouldValidate: true }), className: getClassName(toName) })) })),
        react_1.default.createElement(ErrorMessage, { name: fromName, errors: errors }),
        react_1.default.createElement(ErrorMessage, { name: toName, errors: errors })));
});
function FileInput({ name, required = false, acceptedFileTypes = ".doc,.docx,.xls,.xlsx,.pdf,.txt,.jpg,.jpeg,.png,.gif", multiple = true, inputRef, }) {
    const { control, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: name, defaultValue: [], 
            //render={({ field: { onChange } }) => (
            render: ({ field: { value, onChange, ...field } }) => (react_1.default.createElement(react_bootstrap_1.Form.Control, { ...field, ref: inputRef, type: "file", 
                // file inputs cannot be programmatically set via value for security reasons
                // we keep value handling minimal
                required: required, accept: acceptedFileTypes, isInvalid: !!errors[name], isValid: !errors[name], multiple: multiple, onChange: (event) => {
                    const files = event.target.files;
                    onChange(files);
                } })) }),
        react_1.default.createElement(ErrorMessage, { name: name, errors: errors })));
}
function RadioButtonGroup({ name, options }) {
    const { control } = (0, FormContext_1.useFormContext)();
    return (react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, defaultValue: options[0].value, rules: { required: true }, render: ({ field }) => (react_1.default.createElement(react_bootstrap_1.ButtonGroup, null, options.map((radio, idx) => (react_1.default.createElement(react_bootstrap_1.ToggleButton, { key: idx, id: `radio-${idx}`, type: "radio", variant: "outline-secondary", name: "radio", value: radio.value, checked: field.value === radio.value, onChange: () => field.onChange(radio.value) }, radio.name))))) }));
}
